export const DISPLAY_SNACKBAR = 'DISPLAY_SNACKBAR';
export const VALIDATE_USER_DETAILS = 'VALIDATE_USER_DETAILS';
export const ACKNOWLEDGE_SUBMISSION_REQUEST = 'ACKNOWLEDGE_SUBMISSION_REQUEST';
